// Date/time helpers for availability slots ({ date: "2026-09-30", start_time: "14:00", ... }).

const parseDate = (date) => new Date(`${date}T00:00:00`);

// "14:30" -> "2:30 PM"
export const formatTime = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${hour12}:${String(minutes).padStart(2, "0")} ${period}`;
};

// Shows a slot/booking's time converted into whoever's looking at it's own
// local time zone (the browser already knows it, no extra input needed) —
// falls back to the mentor's plain wall-clock label if the API response
// didn't include the real instant (e.g. an older cached response).
export const formatSlotTime = (startTime, startUtc) => {
  if (startUtc) {
    return new Date(startUtc).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  }
  return formatTime(startTime);
};

// Date + time together, both derived from the same instant when it's
// available, so a slot near midnight can't show a date from one zone next to
// a time from another.
export const formatSlotWhen = (slot) => {
  if (slot.start_utc) {
    const start = new Date(slot.start_utc);
    const dateLabel = start.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
    return `${dateLabel}, ${formatSlotTime(slot.start_time, slot.start_utc)}`;
  }
  return `${formatLongDate(slot.date)}, ${formatTime(slot.start_time)}`;
};

// "2026-09-30" -> { weekday: "Wed", day: 30 } (for the day pickers)
export const dayParts = (date) => {
  const parsed = parseDate(date);
  return {
    weekday: parsed.toLocaleDateString("en-US", { weekday: "short" }),
    day: parsed.getDate(),
  };
};

// "2026-09-30" -> "Wed, Sep 30"
export const formatLongDate = (date) =>
  parseDate(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

// Flat slot list -> [{ date, slots: [...] }] sorted by date, then time.
export const groupSlotsByDate = (slots) => {
  const byDate = new Map();
  slots.forEach((slot) => {
    if (!byDate.has(slot.date)) byDate.set(slot.date, []);
    byDate.get(slot.date).push(slot);
  });
  return [...byDate.keys()].sort().map((date) => ({
    date,
    slots: byDate
      .get(date)
      .sort((a, b) => a.start_time.localeCompare(b.start_time)),
  }));
};

export const apiErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (value) => EMAIL_PATTERN.test(value.trim());
